module.exports = __webpack_public_path__ + "static/media/Parking_solution.21a2f01d.jpeg";